import { render, staticRenderFns } from "./store-tabs.vue?vue&type=template&id=d479461e&scoped=true&"
import script from "./store-tabs.vue?vue&type=script&lang=js&"
export * from "./store-tabs.vue?vue&type=script&lang=js&"
import style0 from "./store-tabs.vue?vue&type=style&index=0&id=d479461e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d479461e",
  null
  
)

export default component.exports